<template>
  <div class="bg_gray">
    <div class="fixed">
      <div class="top_header top_sm">
        <div class="m_flex_box flex_vc flex_jz top_normal">
          <p></p>
          <p>线下业务预约</p>
          <i to="/addApply" class="right" @click="show = true">预约说明</i>
        </div>
      </div>
    </div>
    <div class="pad_top"></div>
    <van-form @submit="onSubmit" validate-trigger="onSubmit">
      <div class="main_ bor_b">
        <div>
          <van-field
            readonly
            value="二手房业务预约"
            label="预约业务类型"
            placeholder="请选择"
          />
        </div>
        <div>
          <van-field
            readonly
            value="市区"
            label="可办理的区域"
            placeholder="请选择"
          />
        </div>
        <div>
          <van-field
            v-model="formData.param1"
            name="realName"
            label="预约人姓名"
            placeholder="请输入预约姓名"
          />
        </div>
        <div>
          <van-field
            v-model="formData.param2"
            name="realName"
            label="预约人身份证"
            placeholder="请输入预约人身份证"
          />
        </div>
        <div>
          <van-field
            readonly
            clickable
            name="picker"
            :value="branchId"
            label="可办理网点"
            placeholder="请选择"
            :rules="[{ required: true, message: '请选择可办理网点' }]"
            @click="showBranch = true"
          />
          <van-popup v-model="showBranch" position="bottom">
            <van-picker
              show-toolbar
              value-key="branchName"
              :columns="list1"
              @confirm="onConfirmBranch"
              @cancel="showBranch = false"
            />
          </van-popup>
        </div>
        <div>
          <van-field
            readonly
            clickable
            name="picker"
            :value="time"
            label="可预约时间"
            placeholder="请选择"
            :rules="[{ required: true, message: '请选择可预约时间' }]"
            @click="showTime = true"
          />
          <van-popup v-model="showTime" position="bottom">
            <van-picker
              show-toolbar
              value-key="time"
              :columns="list2"
              @confirm="onConfirmTime"
              @cancel="showTime = false"
            />
          </van-popup>
        </div>
      </div>
      <div class="main_ bor_b">
        <van-field
          v-model="bargainor"
          name="realName"
          label="出卖方姓名"
          placeholder="请输入出卖方姓名"
          :rules="[{ required: false, message: '请填写出卖方姓名' }]"
        />
        <van-field
          v-model="purchaser"
          name="realName"
          label="买受方姓名"
          placeholder="请输入买受方姓名"
          :rules="[{ required: false, message: '请填写买受方姓名' }]"
        />
        <van-field
          v-model="ownerNo"
          name="realName"
          label="不动产证/房证号"
          placeholder="请输入不动产证/房证号"
          :rules="[{ required: false, message: '请填写不动产证/房证号' }]"
        />
        <van-field
          v-model="houseAddress"
          name="realName"
          label="交易房屋坐落"
          placeholder="请输入交易房屋坐落"
          :rules="[{ required: false, message: '请填写交易房屋坐落' }]"
        />
        <van-field
          v-model="appMsg"
          name="realName"
          label="预约备注"
          placeholder="请输入预约备注"
        />
      </div>
      <div class="main_ bor_b">
        <van-field
          v-model="formData.appPhone"
          type="number"
          name="手机号"
          label="手机号"
          placeholder="请输入手机号"
          :rules="[{ validator: testPhone, message: '请填写正确的手机号' }]"
        >
          <template #button>
            <van-button
              size="small"
              type="info"
              native-type="button"
              @click="sendCode"
              :disabled="codeTime < 120 ? true : false"
              >{{
                codeTime === 120 ? "发送验证码" : codeTime + "秒后重发"
              }}</van-button
            >
          </template>
        </van-field>
        <van-field
          v-model="formData.param3"
          name="验证码"
          label="验证码"
          placeholder="请输入短信验证码"
          maxlength="4"
          :rules="[{ required: true, message: '请填写验证码' }]"
        />
      </div>
      <div class="main_b">
        <div class="blue_con">
          <h4>*重要提醒</h4>
          <p style="color:red;">公积金与组合贷业务请选择北江大厦分点</p>
          <p>
            二手房预约需输入交易双方及房产信息，该信息将被用做线下业务受理使用，请如实填写
          </p>
          <p>若您填写的信息与实际业务受理信息不符，将不予受理</p>
          <p>预约需业务办理本人进行预约，第三方代为预约无效，请知晓！</p>
        </div>
      </div>
      <div class="btn_con">
        <van-button block type="info" native-type="submit">
          提交
        </van-button>
      </div>
    </van-form>
    <div class="m_flex_box flex_vc flex_hc opc_cover" v-show="show">
      <div class="wrapper">
        <h5>预约说明</h5>
        <div class="content_">
          <div>
            <p>1、预约需业务办理本人进行预约，第三方代为预约无效，请知晓！</p>
            <p>
              2、预约成功后，预约将正式生效，请买、卖双方及共有人于约定时间前往网点办理；逾期未办理，将不保留预约信息；
            </p>
            <p>
              3、预约成功后，现场业务办理以预约序号顺序为准，现场不再单独叫号，过号作废，需重新预约。
            </p>
            <p>
              4、若预约时间已满，该预约时间将不显示；
            </p>
            <p>
              5、办理商业贷款的二手房网签业务，不要进行预约，请前往贷款银行办理
            </p>
            <p>
              6、一个预约号，仅可预约办理买卖双方分别为同一人的最多两套房产业务
            </p>
            <p>
              7、一个身份证号仅可预约一次且仅当天有效
            </p>
          </div>
        </div>
        <div class="btn" @click="show = false">确定</div>
      </div>
    </div>
    <div class="m_flex_box flex_vc flex_hc opc_cover" v-show="showPopup">
      <div class="wrapper">
        <h5>预约成功</h5>
        <h4>*请截图留存</h4>
        <div class="content_">
          <div class="m_flex_box flex_jz">
            <p>预约排号：{{ obj.param1 ? obj.param1 : "-" }}</p>
            <p>预约申请人：{{ obj.appName ? obj.appName : "-" }}</p>
          </div>
          <p>预约身份证号：{{ obj.appId ? obj.appId : "-" }}</p>
          <p>预约地点：{{ obj.branchId ? obj.branchId : "-" }}</p>
          <p>
            预约时间：{{ obj.appDate | formatTime
            }}{{ obj.appTime == 1 ? "上午" : "下午" }}
          </p>
          <div class="m_flex_box flex_jz">
            <p>预约出卖方：{{ obj.bargainor ? obj.bargainor : "-" }}</p>
            <p>预约买受方：{{ obj.purchaser ? obj.purchaser : "-" }}</p>
          </div>
          <p>预约手机号：{{ obj.appPhone ? obj.appPhone : "-" }}</p>

          <p>不动产证/房证号：{{ obj.ownerNo ? obj.ownerNo : "-" }}</p>
          <p>预约房屋坐落：{{ obj.houseAddress ? obj.houseAddress : "-" }}</p>
        </div>
        <div class="btn" @click="showPopup = false">确定</div>
      </div>
    </div>
  </div>
</template>

<script>
import commmon from "@/assets/js/common";
import qs from "qs";
export default {
  data() {
    return {
      code: "",
      showPopup: false,
      list1: [
        {
          branchName: "北江大厦分点（公积金、组合贷）",
          id: "0b91843be570405ab6868d87b303d3ed",
        },
        {
          branchName: "坝子街分点",
          id: "0e395c49d6b3439f85a1937dde40eed4",
        },
      ],
      userName: "",
      columns: [1],
      comtent: "",
      fileList: [],
      show: true,
      showPicker: false,
      showAppType: false,
      showArea: false,
      showBranch: false,
      showTime: false,
      branchId: "",
      appDate: "",
      list2: [],
      list3: [],
      time: "",
      finished: false,
      bargainor: "",
      purchaser: "",
      ownerNo: "",
      houseAddress: "",
      appMsg: "",
      codeTime: 120,
      obj: {},
      formData: {
        name: "",
        param1: "",
        param2: "",
        param3: "",
        appType: "1",
        area: "320",
        branchId: "",
        appDate: "",
        appTime: "",
        appPhone: "",
      },
    };
  },
  created() {
    const code = this.getUrlParam("code"); // 截取路径中的code
    if (code == null || code === "") {
      if (commmon.isWX()) {
        let redirect_uri1 =
          "https://www.xzhouse.com.cn/page/generation/xzxxw/#/singlePageUnderLineOrder"; //version admin
        let REDIRECT_URI = encodeURIComponent(redirect_uri1); //
        let url =
          "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx93655237c1aae134&redirect_uri=" +
          REDIRECT_URI +
          "&response_type=code&scope=snsapi_userinfo&state=1&connect_redirect=1#wechat_redirect";

        window.location.href = url;
      }
    } else {
      this.$http
        .post(
          "cms/wechat/permit/getWXUserInfo.do",
          qs.stringify({ code: code })
        )
        .then((res) => {
          if (res.success) {
            if (res.obj.subscribe == 0) {
              window.location.href =
                "https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzUyNzcwNDI1MA==&scene=110#wechat_redirect";
            }
          }
        });
    }
  },
  mounted() {},
  filters: {
    formatTime(data) {
      if (data) {
        return data.split(" ")[0];
      } else {
        return "-";
      }
    },
  },
  methods: {
    getUrlParam(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      let url = window.location.href.split("#")[0];
      let search = url.split("?")[1];
      if (search) {
        var r = search.substr(0).match(reg);
        if (r !== null) return unescape(r[2]);
        return null;
      } else return null;
    },
    testPhone(data) {
      return /^1[3456789]\d{9}$/.test(data);
    },
    sendCode() {
      if (!this.formData.appPhone) {
        this.$toast("请输入正确的手机号");
        return;
      }
      if (this.codeTime === 120) {
        this.$http
          .post(
            "cms/appointment/permit/getMessageCode.do",
            qs.stringify({
              phone: this.formData.appPhone,
            })
          )
          .then((res) => {
            this.$toast(res.msg);
            if (res.success) {
              this.codeTime -= 1;
              let setTimer = setInterval(() => {
                if (this.codeTime > 0) {
                  this.codeTime -= 1;
                } else {
                  this.codeTime = 120;
                  clearInterval(setTimer);
                }
              }, 1000);
            }
          });
      }
    },
    onConfirmBranch(data) {
      this.branchId = data.branchName;
      this.$set(this.formData, "branchId", data.id);
      this.showBranch = false;
      this.getAppointmentConfigTimeListOffline();
    },
    onConfirmTime(data) {
      this.time = data.time;
      this.$set(this.formData, "appDate", data.appDate);
      this.$set(this.formData, "appTime", data.appTime);
      this.showTime = false;
      console.log(this.formData);
    },

    getAppointmentConfigTimeListOffline() {
      this.$http
        .post(
          "cms/appointmentConfig/permit/getAppointmentConfigTimeListOffline.do",
          qs.stringify({
            branchId: this.formData.branchId,
            appType: "1",
          })
        )
        .then((res) => {
          if (res.success) {
            const newArr = [];
            res.obj.forEach(function(item) {
              var num = item.num;
              var time = "上午";
              if (item.appTime == 2) {
                time = "下午";
              }
              item.time =
                item.appDate.substring(0, 10) +
                "-" +
                time +
                "-剩余" +
                num +
                "号";
              newArr.push(item);
            });
            this.$set(this, "list2", newArr);
          } else {
            this.$dialog.alert({
              title: "提示",
              message: res.msg,
            });
            this.finished = true;
          }
        });
    },

    onSubmit() {
      if (!this.bargainor) {
        this.$toast("请输入出卖方姓名!");
      }
      if (!this.purchaser) {
        this.$toast("请输入买受方姓名!");
      }
      if (!this.ownerNo) {
        this.$toast("请输入权属证号!");
      }
      if (!this.houseAddress) {
        this.$toast("请输入交易房屋地址!");
      }
      this.$http({
        url: "cms/appointment/permit/doSendAppointmentOffline.do",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          branchId: this.formData.branchId,
          appMsg: this.appMsg,
          appDate: this.formData.appDate,
          appTime: this.formData.appTime,
          appType: 1,
          area: "320",
          bargainor: this.bargainor,
          purchaser: this.purchaser,
          ownerNo: this.ownerNo,
          param1: this.formData.param1,
          param2: this.formData.param2,
          param3: this.formData.param3,
          appPhone: this.formData.appPhone,
          houseAddress: this.houseAddress,
        },
      }).then((res) => {
        if (res.success) {
          this.showPopup = true;
          this.obj = res.obj;
        } else {
          this.$toast(res.msg);
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.bg_gray {
  background-color: #f5f5f5;
  min-height: 100vh;
}

.top_header {
  height: 0.7rem;
  padding: 0.2rem 0rem;
  width: 7.04rem;
  margin: 0 auto;

  &.top_sm {
    padding: 0.1rem;
  }
}

.pad_top {
  padding-top: 0.9rem;
}

.fixed {
  background-color: #fff;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  z-index: 9;
  border-bottom: 1px solid #f5f5f5;

  .top_normal {
    height: 100%;

    p {
      font-size: 0.32rem;
    }

    i {
      font-size: 0.32rem;
    }

    .right {
      font-size: 0.28rem;
      color: #2f72f5;
    }
  }
}

.btn_con {
  background-color: #fff;
  z-index: 9;
  padding: 0.4rem 0;
  left: 0;
  right: 0;

  /deep/ .van-button {
    height: 0.88rem;
    width: 7.04rem;
    margin: 0 auto;
    border-radius: 0.08rem;
  }
}

.blue_con {
  background-color: #eff4ff;
  color: #2f72f5;
  width: 7.04rem;
  box-sizing: border-box;
  padding: 0.24rem 0.23rem;
  margin: 0 auto 0;
  border-radius: 0.08rem;

  h4 {
    font-weight: 800;
    font-size: 0.26rem;
    margin-bottom: 0.1rem;
  }

  p {
    font-size: 0.24rem;
    line-height: 0.4rem;
  }
}

.main_b {
  padding-top: 0.3rem;
  background-color: #fff;
}

.wrapper {
  height: 9.54rem;
  width: 6.64rem;
  background-color: #fff;

  h5 {
    padding-top: 0.28rem;
    font-size: 0.38rem;
    text-align: center;
    font-weight: 800;
    margin-bottom: 0.3rem;
  }
  h4 {
    font-size: 0.28rem;
    margin-bottom: 0.3rem;
    text-align: center;
    font-weight: 800;
    color: red;
  }

  .content_ {
    height: 60%;
    box-sizing: border-box;
    padding: 0 0.4rem 0;
    overflow: auto;
    font-size: 0.28rem;
    .m_flex_box {
      p {
        width: 50%;
      }
    }
    p {
      margin-bottom: 0.35rem;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .btn {
    width: 2.92rem;
    line-height: 0.82rem;
    text-align: center;
    color: #fff;
    background-color: #2f72f5;
    border-radius: 0.08rem;
    font-size: 0.28rem;
    margin: 0.45rem auto 0;
  }
}

.opc_cover {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 2;
}
</style>
